import { supabase } from './auth';
import { localDate } from '../utils/date';

export type CheckInFeeling = 'rough' | 'okay' | 'strong';

export interface DailyCheckIn {
  day: string;
  feeling: CheckInFeeling;
  note: string | null;
}

const today = () => localDate();

export const getTodaysCheckIn = async (): Promise<DailyCheckIn | null> => {
  const { data, error } = await supabase
    .from('daily_checkins')
    .select('day, feeling, note')
    .eq('day', today())
    .maybeSingle();

  if (error) throw error;
  return (data as DailyCheckIn | null) ?? null;
};

export const saveTodaysCheckIn = async (
  feeling: CheckInFeeling,
  note: string | null
): Promise<void> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { error } = await supabase.from('daily_checkins').upsert(
    {
      user_id: user.id,
      day: today(),
      feeling,
      note,
      updated_at: new Date().toISOString(),
    },
    { onConflict: 'user_id,day' }
  );
  if (error) throw error;
};
